import { InputSwitch } from "primereact/inputswitch";

const AIEduSwitch = (props) => {
    return <InputSwitch {...props} />;
};

export default AIEduSwitch;
